let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gUZma")).then(() => parcelRequire('amnp6'));